export default __webpack_public_path__ + "1b12650ba65fda6f4dc2df62ec482937.svg";